export default __webpack_public_path__ + "7d35af151304bdeb40ee7a4334cb46e3.svg";